export default __webpack_public_path__ + "static/media/croptop-large-back.b776e39b.jpg";